import { err } from "neverthrow";
import { getStateAndOtherInfoFromStorage } from "supertokens-web-js/recipe/thirdparty";
import type { ExtraState } from "./types";

export function handleSuperTokensError(error: any, message: string) {
  if (error.isSuperTokensGeneralError) return err(error.message as string);
  return err(message);
}

const EXCLUDED_PARAMS = new Set(["returnTo", "state", "phone", "email", "code"]);

export function getForwardingParams(search = window.location.search) {
  const searchParams = new URLSearchParams(search);
  return new URLSearchParams([...searchParams.entries()].filter(([key]) => !EXCLUDED_PARAMS.has(key)));
}

export function forwardParams(url: string) {
  const existingParams = new URLSearchParams(url.split("?")[1]);
  for (const [key, value] of getForwardingParams().entries()) {
    existingParams.set(key, value);
  }
  return `${url.split("?")[0]}?${existingParams.toString()}`;
}

export function getReturnTo() {
  const search = getStateAndOtherInfoFromStorage<ExtraState>()?.search ?? window.location.search;
  return new URLSearchParams(search).get("returnTo") ?? "/";
}
